export enum CourseType {
  E_LEARNING = "E_LEARNING",
  FLIP_LEARNING = "FLIP_LEARNING",
  LIVE_LEARNING = "LIVE_LEARNING"
}
